"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.PROJECT_USERS, (table)=>{
        table.primary([
            'base_id',
            'fk_user_id'
        ]);
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.PROJECT_USERS, (table)=>{
        table.dropPrimary();
    });
};
